import styled from 'styled-components';

/**
 * Base chrome for the transcript header's toolbar buttons (icon and text
 * pills alike). Extracted from `Transcript.tsx` (PLAT-11039) so the fused
 * toggle pill in `HighlightTogglePill.tsx` can build on the same base
 * instead of duplicating it — see CLAUDE.md → "Architecture Guardrails"
 * rule 5 (compose into Transcript, never grow it).
 *
 * `isPressed` is the active/toggled state: gold text on the elevated
 * surface. Content-tinted variants (Quotes / Clips / Cap) override the
 * pressed colors with their own tokens.
 */
export const PanelButton = styled.button.attrs(
  (props: { isPressed: boolean }) => props,
)`
  border: none;
  border-radius: var(--radius-button);
  cursor: pointer;
  background-color: ${props =>
    props.isPressed ? 'var(--surface-elevated)' : 'transparent'};
  color: ${props =>
    props.isPressed ? 'var(--accent)' : 'var(--text-secondary)'};
  height: 100%;
  display: flex;
  align-items: center;
  padding: 4px;
  transition: all 150ms ease-out;

  &:hover {
    background-color: var(--surface-elevated);
    color: ${props =>
      props.isPressed ? 'var(--accent)' : 'var(--foreground)'};
  }

  &:active {
    background-color: var(--gray-700);
    scale: 0.98;
  }
`;
